import { render, staticRenderFns } from "./classPushPartner.vue?vue&type=template&id=0dc6cbeb&scoped=true"
import script from "./classPushPartner.vue?vue&type=script&lang=js"
export * from "./classPushPartner.vue?vue&type=script&lang=js"
import style0 from "./classPushPartner.vue?vue&type=style&index=0&id=0dc6cbeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6cbeb",
  null
  
)

export default component.exports